// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__9_9VD","hide":"styles_hide__672tR"};